// src/types/User.ts
import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const UserService = { 
   async getUser(): Promise<AxiosResponse> {
    const res = await httpClient.get<AxiosResponse>(`${apiRoutePrefix}/getUser`);
    return res;
  },
  async getUserSubscription(userId: any): Promise<AxiosResponse> {
    const res = await httpClient.get<AxiosResponse>(`${apiRoutePrefix}/user/subscription`);
    return res;
  },
   async updateUserTutorialFlag(userId: string, hasWatched: boolean): Promise<AxiosResponse> {
    return httpClient.put(`${apiRoutePrefix}/user/${userId}/tutorial-status`, { hasWatched });
  },
};
